import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SseService } from 'src/app/services/SseService';
import { CookieService } from 'ngx-cookie-service';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { GestionService } from 'src/app/services/gestion.services';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { BrokerService } from 'src/app/services/broker.services';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { TemaService } from 'src/app/services/tema.services';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { OAuthService } from 'src/app/services/oauth.service';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { translateMetaApiError, translateMetaApiHttpError } from 'src/app/services/meta-api-error-messages';
import { BrokerTimeService, MarketSchedule } from 'src/app/services/broker-time.service';
import { IbkrOrdenService } from 'src/app/services/ibkr-orden.service';
import { ColaOrdenesService } from 'src/app/services/cola-ordenes.service';
import { esDiaHabil, fechaHoyIso, fechaOperacionBackend } from 'src/app/shared/utils/date-utils';
import { CotizacionPrecio } from '../cotizacion-fuente/cotizacion-fuente.component';

export interface companiaMercado {
  iso: string;
  conid?: number;
  descripcion?: string;
  fecha?: string;
  idNectum?: number;
  n?: number;
  numcciones?: number;
  precioteorico?: number;
  stoploss?: number;
  stoplosspor?: number;
}
interface WhatIfAmount { amount: string; commission: string; total: string; }
interface WhatIfMetric { current: string; change: string; after: string; }
interface WhatIfResponse {
  amount: { amount: string; commission: string; total: string };
  equity: { current: string; change: string; after: string };
  initial: { current: string; change: string; after: string };
  maintenance: { current: string; change: string; after: string };
  position: { current: string; change: string; after: string };
  warn?: string | null;
  error?: string | null;
  warns?: string[];                 // nuevo
  accruedInterest?: string | null;  // nuevo
}

@Component({
  selector: 'app-opeentrada-dialog',
  templateUrl: './opeentrada-dialog.component.html',
  styleUrl: './opeentrada-dialog.component.scss'
})
export class OpeentradaDialogComponent implements OnInit, OnDestroy {
  public optimawalletOpe: OptimalWallet;
  public companiaOpe: any;
  public rentabilidad: any;
  public listaCompania: companiaMercado[] = [];
  public coste: any;
  riesgooperacion: any;
  stoploss: number;
  nombreCuenta: string = '';
  public url: string;
  public operacion: operationinterface;
  public diaHabil: boolean = false;
  public companiaSelect: any;
  public isBroker: boolean = false;
  public contadorCompania: string;
  public isDark: boolean = false;
  public subtema: Subscription;
  public conidcfd: number = 0;
  public precioTeoricoTemp: number = 0;
  /** La fecha elegida no tiene cotización en ninguna fuente: no se puede registrar. */
  public isHabil: boolean = false;
  /** Envío en curso: evita el doble clic en Aceptar. */
  public enviando: boolean = false;
  /** Último precio de <app-cotizacion-fuente> (base de LMT/STP). */
  public ultimoPrecio: number | null = null;
  public porcentaje: number = 1;
  public activateedPrecioOrden: boolean = false;
  whatIfData: WhatIfResponse | null = null;
  whatIfLoading = false;
  whatIfError: string | null = null;
  private whatIfDebounce: any;

  get showWhatIf(): boolean {
    return this.isBroker && this.optimawalletOpe?.tipoBroker !== 'METAAPI';
  }
  theme: any;
  marketCountdownText: string = '';
  marketDisplayName: string = '';
  marketTimezone: string = '';
  isMarketOpen: boolean = false;
  /** Solo CERRADO con horario conocido; con horario desconocido no se avisa. */
  isMarketClosed: boolean = false;
  marketEventLabel: string = '';
  marketEventClock: string = '';
  private marketCountdownTimer: any = null;
  private marketSchedule: MarketSchedule | null = null;
  symbolSpec: any = null;
  currentPrice: any = null;
  currentTick: any = null;

  ordersData = {
    orders: [
      {
        orderType: 'MKT',
        ticker: 'AAPL',
        side: 'BUY',
        quantity: 0,
        // listingExchange: 'SMART',//
        remainingquantity: 0,
        acctId: 'DU149954',
        cOID: 'nctminvst1714425916446-AAPL0:A',
        secType: '265598:STK',
        filledquantity: 0,
        parentId: 'nctminvst1714425916446-AAPL0:A',
        tif: 'GTC',//
        //  outsideRTH: false,
        referrer: 'modelosdeinversion',
        useAdaptive: false,
        conid: 265598,
        price: 0,
        // Cartera del broker: el backend enlaza con ella los SL/TP activos de la operación
        carteraid: 0,
        subcarteraid: 0
      }
    ]
  };

  orderType: string[] = [
    'MKT',
    'LMT',
    'STP'
  ]
  stkcfd: any;
  /** Modo de esta operación: true = solo registro en API, false = orden al broker (Live). */
  sincro: boolean = true;
  isArray: boolean = false;
  public licencia: string;

  myControl = new FormControl();
  options: any;
  filteredOptions: Observable<string[]>;

  constructor(public dialogRef: MatDialogRef<OpeentradaDialogComponent>,
    private _gestionsv: GestionService,
    private _cookieService: CookieService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sseservice: SseService,
    private _sseService: SseService,
    private datePipe: DatePipe,
    private _brokerService: BrokerService,
    public dialog: MatDialog,
  private temaservicio: TemaService, private oauthService: OAuthService,
  private cdr: ChangeDetectorRef,
  private brokerAdapterFactory: BrokerAdapterFactory,
  private metaApiService: MetaApiService,
  private brokerTimeService: BrokerTimeService,
  private ibkrOrdenService: IbkrOrdenService,
  private colaOrdenesService: ColaOrdenesService,
  private toastr: ToastrService) {
    this.operacion = {
      estado: '',
      acumuladocomision: 0,
      bajista: false,
      beneficioacumulado: 0,
      beneficioperdida: 0,
      cantidadacciones: 0,
      capitalEmpleado: 0,
      capitalactual: 0,
      contador: 0,
      comision: 0,
      cotizacion: 0,
      costeoperacion: 0,
      costereembolso: 0,
      efectivo: 0, valorriesgo: 0,
      fondosdisponibles: 0,
      margentotal: 0,
      //oldCotizacion: 0,
      podercompra: 0,
      precioentradareal: 0,
      preciosalidareal: 0,
      reembolsoriesgo: 0,
      riesgooperacion: 0,
      riesgomaximo: 0,
      stoplossinicial: 0,
      valorlatente: 0,
      valorlatentepor: 0,
      valorliquidativo: 0,
      filasumatorio: 0,
      procesado: 0,
      fechaCompra: '', //tipo calendar ??
      fechaCotizacion: '',
      fechaOperacion: '',
      lastExecutionTimer: 0, //timestamp
      idoperacion: 0,
      idNectum: 0,
      idcartera: 0,
      idoperacionasociada: 0,
      numeroreconfiguracion: 0,
      numoperaciones: 0,
      orderId: 0,
      posicionsimultanea: 0,
      posicion: 0,
      conid: 0,
      hora: 0,
      horaCotizacion: 0,
      isooper: '',
      nombreCompania: '',
      order_ref: '',
      secType: '',
      tipoOperacion: '',
      fechaDate: '',//variable temporal para eextaer datos de sql2o
      tiporiesgo: '',
      broker: false, idmodelo: 0, carteraid: 0, subcarteraid: 0, margenbroker: 0,
      porstoploss: 0, porprofit: 0,
    };
    this.licencia = this._cookieService.get('auth_token');
  }


  // Decimales según tipo de instrumento (CFD = 5, resto = 2)
  get decimales(): number {
    return this.stkcfd === 'CFD' ? 5 : 2;
  }

  private initializeMarketCountdown(schedule: MarketSchedule): void {
    this.marketSchedule = schedule;
    const isMetaApi = this.optimawalletOpe?.tipoBroker === 'METAAPI';
    this.marketDisplayName = isMetaApi
      ? (schedule.mtServer || 'Mercado')
      : (schedule.iso || schedule.nombre || 'Mercado');
    this.marketTimezone = schedule.timezone || 'UTC';

    this.updateMarketCountdown();

    if (this.marketCountdownTimer) {
      clearInterval(this.marketCountdownTimer);
    }
    this.marketCountdownTimer = setInterval(() => this.updateMarketCountdown(), 1000);
  }

  private clearMarketCountdown(): void {
    if (this.marketCountdownTimer) {
      clearInterval(this.marketCountdownTimer);
      this.marketCountdownTimer = null;
    }
  }

  private resetMarketCountdown(): void {
    this.clearMarketCountdown();
    this.marketCountdownText = '';
    this.marketDisplayName = '';
    this.marketTimezone = '';
    this.marketEventLabel = '';
    this.marketEventClock = '';
    this.marketSchedule = null;
    this.cdr.markForCheck();
  }

  private updateMarketCountdown(): void {
    if (!this.marketSchedule) {
      this.resetMarketCountdown();
      return;
    }

    const now = new Date();
    const info = this.brokerTimeService.estadoMercado(this.marketSchedule, now);
    this.isMarketOpen = info.estado === 'ABIERTO';
    this.isMarketClosed = info.estado === 'CERRADO';

    if (info.feriado) {
      this.marketCountdownText = 'Mercado cerrado por feriado.';
      this.marketEventLabel = 'Cerrado';
      this.marketEventClock = '';
      this.cdr.markForCheck();
      return;
    }
    if (!info.evento) {
      this.resetMarketCountdown();
      return;
    }

    const { tipo, fecha } = info.evento;
    this.marketCountdownText = `${tipo} en ${this.brokerTimeService.formatDuration(fecha.getTime() - now.getTime())}`;
    this.marketEventLabel = tipo;
    this.marketEventClock = this.brokerTimeService.formatEventTime(fecha, this.marketSchedule.timezone);
    this.cdr.markForCheck();
  }

  private loadMarketSchedule(idNectum: number | undefined): void {
    this.brokerTimeService.getMarketSchedule(idNectum, this.optimawalletOpe).subscribe(schedule => {
      if (schedule) this.initializeMarketCountdown(schedule);
      else this.resetMarketCountdown();
    });
  }

  /** La orden va al broker real (no solo registro en API) con el mercado cerrado: solo se avisa. */
  get avisoMercadoCerrado(): boolean {
    return this.isBroker && !this.sincro && this.isMarketClosed;
  }

  /** En Live la orden sale hoy: se fija la fecha a hoy. */
  onCambioSincro(): void {
    if (!this.sincro) this.companiaOpe.fecha = fechaHoyIso();
  }

  /** STK/CFD cambia decimales y el contrato (conidcfd) del what-if. */
  async onCambioStkcfd(): Promise<void> {
    await this.calculoCoste();
    await this.calculoRiesgo();
    this.debouncedFetchWhatIf();
  }


  ngOnInit(): void {

    this.optimawalletOpe = JSON.parse(JSON.stringify(this.data.optimaWallet));
    //cuando estamos en METAAPI se debe recalcular this.companiaOpe.numcciones = Math.round( valorriesgo / (this.symbolspec.contractSize * precioentrada * porstoploss) )
    this.companiaOpe = JSON.parse(JSON.stringify(this.data.compania));
    this.companiaSelect = JSON.parse(JSON.stringify(this.data.compania));
    this.companiaOpe.fecha = fechaHoyIso();
    this.nombreCuenta = this.optimawalletOpe.nombre;
    this.cargarContadorCompania(this.companiaOpe);
    this.listaCompania = JSON.parse(JSON.stringify(this.data.listaCompnia ?? []));
    this.options = this.listaCompania;
    this.isBroker = this.data.isBroker;
    this.stkcfd = this.data.stkcfd;
    this.sincro = this.optimawalletOpe.sincro ?? true;
    this.myControl.setValue(this.companiaOpe.iso, { emitEvent: false });
    this.calculoCoste();
    this.calculoRiesgo();
    this.recalcularStoploss();

    this.loadMarketSchedule(this.companiaOpe.idNectum);

    if (this.optimawalletOpe?.tipoBroker === 'METAAPI') {
      this.cargarSymbolSpec();
    }

    this.subtema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
    if (this.isBroker) this.debouncedFetchWhatIf();
  }

  /** Precio de <app-cotizacion-fuente>: tiempo real si la fecha es hoy, histórico si no. */
  onPrecio(precio: CotizacionPrecio): void {
    this.ultimoPrecio = precio.last;
    if (Number(this.companiaOpe.precioteorico) !== precio.last) {
      this.recalcular(precio.last, 'precio');
    }
  }

  private debouncedFetchWhatIf(delay = 300) {
    clearTimeout(this.whatIfDebounce);
    this.whatIfDebounce = setTimeout(() => this.fetchWhatIf(), delay);
  }

  /** Rellena la orden IBKR con la compañía, cantidad y dirección actuales. */
  private prepararOrdenIbkr(): void {
    const bajistaStr = this.optimawalletOpe.bajista ? 'B' : 'A';
    let tempconid = this.companiaOpe.conid;
    if (this.stkcfd == 'CFD')
      tempconid = this.companiaOpe.conidcfd;
    const orden = this.ordersData.orders[0];
    orden.side = this.optimawalletOpe.bajista ? 'SELL' : 'BUY';
    orden.ticker = this.companiaOpe.iso;
    orden.quantity = this.companiaOpe.numcciones;
    orden.acctId = this.optimawalletOpe.nombre;
    orden.cOID = 'nctminvst' + new Date().getTime() + this.companiaOpe.idNectum + '-' + this.contadorCompania + ':' + bajistaStr;
    orden.secType = tempconid + ':' + this.stkcfd;
    orden.parentId = orden.cOID;
    orden.conid = tempconid;
    orden.carteraid = this.optimawalletOpe.idcartera;
    orden.subcarteraid = this.optimawalletOpe.idcartera;
  }

  private fetchWhatIf(): void {
    if (!this.isBroker) return;
    if (this.optimawalletOpe?.tipoBroker === 'METAAPI') {
      this.whatIfData = null;
      this.whatIfLoading = false;
      return;
    }
    if (!this.nombreCuenta) return; // asegúrate de tener el nombre de cuenta
    const urlwhatif = `/iserver/account/${this.nombreCuenta}/orders/whatif`;
    this.prepararOrdenIbkr();

    const ordersDatam = this.ordersData; // usa tu estructura de orden actual

    this.whatIfLoading = true;
    this.whatIfError = null;

    this.oauthService.apiPostIbrk(urlwhatif, ordersDatam).subscribe({
      next: (res: WhatIfResponse) => {
        this.whatIfData = res;
        //enviar esto a guardar en un endpoint
        this._sseService.apiPostNew('broker/guardarWhatIf', { whatIf: res, conid: this.companiaOpe.conid, cuenta: this.nombreCuenta, cOID: this.ordersData.orders[0].cOID }, this.licencia).subscribe({
          next: (data: any) => { }
        });
      },
      error: (err) => {
        this.whatIfError = (err?.error?.message || 'Error obteniendo What-If');
        this.whatIfData = null;
      },
      complete: () => this.whatIfLoading = false
    });
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option: any) => option.iso.toLowerCase().includes(filterValue));
  }

  selected(event: MatAutocompleteSelectedEvent) {
    let iso = event.option.value;
    this.companiaSelect = this.listaCompania.find((compania: any) => compania.iso === iso);
    this.seleccionarCompania();
  }

  async calculoCoste(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.coste = Number(Number(this.companiaOpe.numcciones) * this.companiaOpe.precioteorico).toFixed(this.decimales);
      resolve();
    });

  }
  async calculoRiesgo(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.optimawalletOpe.tiporiesgo == 'LIMITADO' && this.companiaOpe.numcciones > 0) {
        let calculoriesgoop = (this.companiaOpe.precioteorico - (this.companiaOpe.precioteorico - (this.companiaOpe.precioteorico * this.optimawalletOpe.stopLoss / 100))) * this.companiaOpe.numcciones;
        this.riesgooperacion = Number(calculoriesgoop).toFixed(this.decimales);
      } else {
        this.riesgooperacion = this.coste;
      }
      resolve();
    });
  }

  async recalcularStoploss(): Promise<void> {
    return new Promise<void>((resolve) => {
      let calculoStoploss = (Number(this.companiaOpe.precioteorico) - Number((Number(this.companiaOpe.precioteorico) * this.optimawalletOpe.stopLoss / 100)));
      if (this.optimawalletOpe.bajista)
        calculoStoploss = (Number(this.companiaOpe.precioteorico) + Number((Number(this.companiaOpe.precioteorico) * this.optimawalletOpe.stopLoss / 100)));

      this.stoploss = Number(calculoStoploss.toFixed(this.decimales));
      resolve();
    });
  }

  private cargarSymbolSpec(): Promise<void> {
    return new Promise<void>((resolve) => {
      const accountId = this.brokerAdapterFactory.getAccountId(this.optimawalletOpe);
      this.metaApiService.getSymbolSpecification(accountId, this.companiaOpe.iso).subscribe({
        next: (spec: any) => {
          this.symbolSpec = spec;
          resolve();
        },
        error: () => resolve()
      });
    });
  }

  private ajustarCantidadMetaApi(cantidad: number): number {
    if (!this.symbolSpec) return cantidad;
    let n = Math.round(cantidad * 100) / 100;
    const minVolume = this.symbolSpec.minVolume ?? 0;
    const volumeStep = this.symbolSpec.volumeStep ?? 0;
    if (minVolume && n < minVolume) {
      n = minVolume;
    } else if (volumeStep > 0) {
      const remainder = n % volumeStep;
      if (remainder !== 0)
        n = n - remainder;
    }
    return n;
  }

  calcularNacciones(): Promise<void> {
    return new Promise<void>((resolve) => {


      if (this.optimawalletOpe?.tipoBroker === 'METAAPI') {
      this.cargarSymbolSpec().then(async () => {
          if (this.optimawalletOpe.tiporiesgo == 'LIMITADO') {
          this.companiaOpe.numcciones = this.data.optimaWallet.riesgo / (this.symbolSpec.contractSize * this.companiaOpe.precioteorico * (this.data.optimaWallet.stopLoss/ 100));
          if (this.optimawalletOpe.bajista)
            this.companiaOpe.numcciones = this.data.optimaWallet.riesgo / (this.symbolSpec.contractSize * this.companiaOpe.precioteorico * (this.data.optimaWallet.stopLoss / 100));
          } else if (this.optimawalletOpe.tiporiesgo == 'FIJO') {
            this.companiaOpe.numcciones = this.riesgooperacion / (this.symbolSpec.contractSize * this.companiaOpe.precioteorico);
          }
          this.companiaOpe.numcciones = this.ajustarCantidadMetaApi(this.companiaOpe.numcciones);
          await this.calculoCoste();
          await this.calculoRiesgo();
          this.cdr.markForCheck();
          resolve();
      });
      return;
    }else{
      if (this.optimawalletOpe.tiporiesgo == 'LIMITADO') {
        this.companiaOpe.numcciones = Math.round(this.riesgooperacion / (Number(this.companiaOpe.precioteorico) - this.stoploss));//1000 / (10-12)
        if (this.optimawalletOpe.bajista)
          this.companiaOpe.numcciones = Math.round(Number(this.riesgooperacion) / (this.stoploss - Number(this.companiaOpe.precioteorico)));// 1000 / (10+12)
      } else if (this.optimawalletOpe.tiporiesgo == 'FIJO') {
        this.companiaOpe.numcciones = Math.round(this.riesgooperacion / this.companiaOpe.precioteorico);
      }
    }

      resolve();
    });
  }

  async recalcular(data: any, campo: any) {
    if (this.companiaOpe.precioteorico > 0) {

      if (campo == 'precio') {

        this.precioTeoricoTemp = data;
        this.companiaOpe.precioteorico = data;
        await this.recalcularStoploss();
        await this.calcularNacciones();
        await this.calculoRiesgo();
        await this.calculoCoste();

      }
      else if (campo == 'nacciones') {
        this.companiaOpe.numcciones = this.optimawalletOpe?.tipoBroker === 'METAAPI'
          ? this.ajustarCantidadMetaApi(data)
          : data;

        this.riesgooperacion = ((this.companiaOpe.precioteorico - this.stoploss) * this.companiaOpe.numcciones);

        this.coste = (this.companiaOpe.numcciones * this.companiaOpe.precioteorico);
      }
      this.debouncedFetchWhatIf();

    } else {
      this.companiaOpe.precioteorico = this.precioTeoricoTemp;
      this.toastr.error('Valor cotizacion debe ser mayor a 0', '', { timeOut: 5000 });
    }

  }

  registrar() {
    if (this.enviando) return;
    if (!this.isBroker || this.sincro) {
      this.guardarApi();
    } else {
      if (this.optimawalletOpe?.tipoBroker === 'METAAPI') {
        this.enviando = true;
        this.metaApiService.verificarAlgoTradingParaOperar().subscribe(activo => {
          this.enviando = false;
          if (activo) this.enviarBroker();
        });
        return;
      }
      this.enviarBroker();
    }
  }

  private enviarBroker() {
    if (this.avisoMercadoCerrado) {
      this.toastr.warning('Mercado cerrado: la orden puede ser rechazada o ejecutarse en la próxima apertura.', 'Aviso', { timeOut: 8000 });
    }
    this.guardarBroker();
  }

  guardarApi() {
    let url = 'registraroperacion';
    this.crearOperacion();
    let licencia = this._cookieService.get('auth_token');
    if (this.diaHabil) {
      this.enviando = true;
      // order_ref null: con '' OperacionImpl.crear (WHERE ... OR order_ref = :orderref) toma como
      // duplicada cualquier fila con order_ref vacío y no inserta la entrada.
      this._sseservice.apiPostNew(url, { ...this.operacion, order_ref: null }, licencia).subscribe({
        next: (data: any) => {
          this.enviando = false;
          if (data.estado) {
            if (this.isBroker) {
              this._brokerService.updateactualizarCarteraBroker(data.estado);
              this._brokerService.updatecargarListas(true);
            } else {
              this._gestionsv.updateactualizarCartera(data.estado);
            }
            this.dialogRef.close(data.estado);
          } else {
            this.toastr.error(data.error, 'Error', { timeOut: 5000 });
            this.dialog.open(ConfirmDialogComponent, {
              width: '380px',
              panelClass: this.theme,
              data: {
                msj: data.error,
                ocultarCancelar: true
              }
            });
          }
        },
        error: (err: any) => {
          this.enviando = false;
          this.toastr.error('No se registró la entrada: ' + (err?.error?.message ?? err?.message ?? 'error de red'), 'Error', { timeOut: 8000 });
        }
      });
    } else {
      this.toastr.error('Dia de la operacion debe ser Habil', '', { timeOut: 5000 });

    }
  }

  guardarBroker() {
    // Sin contador la orden y su operación no tendrían isooper
    if (!this.contadorCompania) {
      this.toastr.error('Hubo un error al intentar guardar operacion Intente de nuevo', 'Error', { timeOut: 30000 });
      return;
    }
    if (this.optimawalletOpe?.tipoBroker === 'METAAPI') {
      const adapter = this.brokerAdapterFactory.getAdapter(this.optimawalletOpe);
      const accountId = this.brokerAdapterFactory.getAccountId(this.optimawalletOpe);
      const side = this.optimawalletOpe.bajista ? 'SELL' : 'BUY';
      const actionType = side === 'BUY' ? 'ORDER_TYPE_BUY' : 'ORDER_TYPE_SELL';
      const trade = {
        actionType,
        symbol: this.companiaOpe.iso,
        volume: this.companiaOpe.numcciones,
      };
      const licencia = this._cookieService.get('auth_token');
      this.enviando = true;
      adapter.placeOrder(accountId, trade).subscribe({
        next: (res: any) => {
          this.enviando = false;
          // catchError in placeOrder wraps HTTP errors as { error }
          if (res?.error) {
            const httpErr = res.error;
            const msg = httpErr?.error?.message ?? httpErr?.message ?? JSON.stringify(httpErr);
            const errorClass = httpErr?.error?.error;
            this.toastr.error('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg), 'Error', { timeOut: 30000 });
            return;
          }
          // MetaAPI returns stringCode; only TRADE_RETCODE_DONE (10009) means success
          if (res?.stringCode && res.stringCode !== 'TRADE_RETCODE_DONE') {
            const msg = translateMetaApiError(res.stringCode, res.message);
            this.toastr.error('MetaAPI: ' + msg + ' (' + res.stringCode + ')', 'Error', { timeOut: 30000 });
            return;
          }
          const cOID = 'nctminvst' + Date.now() + (this.companiaOpe.idNectum ?? '') + '-' + this.contadorCompania + ':' + (side === 'BUY' ? 'A' : 'B');
          const orderRecord = [{
            ticker: this.companiaOpe.iso,
            side,
            quantity: this.companiaOpe.numcciones,
            acctId: this.optimawalletOpe.nombre,
            orderType: 'MKT',
            orderId: res?.orderId ?? 0,
            secType: this.companiaOpe.conid + ':' + this.stkcfd,
            status: 'Submitted',
            cOID,
            // Como en IBKR: el backend saca el idnectum del parentId
            parentId: cOID,
            carteraid: this.optimawalletOpe.idcartera,
            subcarteraid: this.optimawalletOpe.idcartera,
            origen: 'ENTRADA_MANUAL',
          }];
          this._sseService.apiPostNew('broker/orderNuevo', orderRecord, licencia).subscribe({
            next: (data: any) => {
              if (data.status) {
                this.guardarOperacionBroker(this.companiaOpe.conid);
                this._brokerService.updatecargarListas(true);
              }
            }
          });
          this.dialogRef.close();
        },
        error: (err: any) => {
          this.enviando = false;
          const msg = err?.error?.message ?? err?.message ?? 'unknown';
          const errorClass = err?.error?.error;
          this.toastr.error('MetaAPI error: ' + translateMetaApiHttpError(errorClass, msg), 'Error', { timeOut: 30000 });
        }
      });
      return;
    }
    this.prepararOrdenIbkr();
    if (this.ordersData.orders[0].cOID.includes('undefined')) {
      this.toastr.error('Hubo un error al intentar guardar operacion Intente de nuevo', 'Error', { timeOut: 30000 });
      return;
    }
    this.enviando = true;
    this.ibkrOrdenService.registrarYEnviar(this.ordersData, this.optimawalletOpe.nombre, this.theme, 'ENTRADA_MANUAL')
      .then(ok => { if (ok) this.guardarOperacionBroker(this.ordersData.orders[0].conid); })
      .finally(() => {
        this.enviando = false;
        this.dialogRef.close();
      });
  }

  /**
   * Entrada en vivo: guarda también su operación (tmp_operacion) con el isooper de la orden, para que la
   * posición tenga operación asociada en /broker y se le puedan poner SL/TP. El SL es el que sale del
   * stopLoss de la cartera del broker, el mismo con el que se calculó el riesgo.
   */
  private guardarOperacionBroker(conid: number): void {
    this.crearOperacion();
    const operacion: any = {
      ...this.operacion,
      isooper: this.contadorCompania,
      // En bajista la apertura se guarda como SALIDA (misma convención que el modelo)
      tipoOperacion: this.optimawalletOpe.bajista ? 'SALIDA' : 'ENTRADA',
      nombreCompania: this.companiaOpe.iso,
      conid,
      stoploss: this.stoploss,
      estado: 'PENDIENTE-ENVIO',
      carteraid: this.optimawalletOpe.idcartera,
      subcarteraid: this.optimawalletOpe.idcartera
    };
    this.colaOrdenesService.saveOperacionesToDB([operacion], this.optimawalletOpe.idcartera).subscribe({
      next: (r: any) => {
        if (r?.status === false) this.toastr.warning('Orden enviada, pero no se registró su operación: ' + (r.message ?? ''), 'Entrada');
      },
      error: () => this.toastr.warning('Orden enviada, pero no se registró su operación', 'Entrada')
    });
  }

  crearOperacion() {
    this.diaHabil = esDiaHabil(this.companiaOpe.fecha);
    if (this.diaHabil) {
      this.companiaOpe.fecha = this.datePipe.transform(this.companiaOpe.fecha, 'yyyy-MM-dd');
    }
    this.operacion.bajista = this.optimawalletOpe.bajista;
    this.operacion.cantidadacciones = this.companiaOpe.numcciones;
    this.operacion.idNectum = this.companiaOpe.idNectum;
    this.operacion.idcartera = this.optimawalletOpe.idcartera;
    this.operacion.isooper = this.companiaOpe.iso;
    this.operacion.secType = this.stkcfd || 'STK';// stk= stock, cfd=cfd (para el broker)
    this.operacion.cotizacion = this.companiaOpe.precioteorico;
    this.operacion.riesgooperacion = this.riesgooperacion;
    this.operacion.tiporiesgo = this.optimawalletOpe.tiporiesgo;
    this.operacion.stoplossinicial = this.stoploss;
    this.operacion.fechaOperacion = fechaOperacionBackend(this.companiaOpe.fecha);
    this.operacion.costeoperacion = this.coste;
    this.operacion.tipoOperacion = 'ENTRADA';
    this.operacion.precioentradareal = this.companiaOpe.precioteorico;
  }

  seleccionarCompania() {
    const fecha = this.sincro ? this.companiaOpe.fecha : fechaHoyIso();
    this.cargarContadorCompania(this.companiaSelect);
    this.companiaOpe = this.companiaSelect;
    // La fecha elegida se mantiene al cambiar de compañía (en Live siempre es hoy)
    this.companiaOpe.fecha = fecha;
    this.ultimoPrecio = null;
    this.loadMarketSchedule(this.companiaOpe.idNectum);
  }

  cargarContadorCompania(compania: companiaMercado) {
    let jasonData = {
      idcartera: this.optimawalletOpe.idcartera,
      idnectum: compania.idNectum
    }
    let licencia = this._cookieService.get('auth_token');
    this._sseservice.apiPostNew('broker/contador', jasonData, licencia).subscribe({
      next: (data: any) => {
        if (data.contador) {
          this.contadorCompania = data.contador;
        }
      }
    });
  }

  activarPrecioOrden() {
    this.recalcularStoploss();
    const base = Number(this.ultimoPrecio ?? this.companiaOpe.precioteorico);
    const porcentaje = parseFloat((base * (this.porcentaje / 100)).toFixed(this.decimales));
    const precioActual = parseFloat(base.toFixed(this.decimales));

    if (this.ordersData.orders[0].orderType == 'LMT' || this.ordersData.orders[0].orderType == 'STP') {
      this.activateedPrecioOrden = true;
      // Compra (alcista): STP por encima, LMT por debajo; venta (bajista): al revés
      const porEncima = (this.ordersData.orders[0].orderType == 'STP') !== !!this.optimawalletOpe.bajista;
      this.ordersData.orders[0].price = parseFloat((porEncima ? precioActual + porcentaje : precioActual - porcentaje).toFixed(this.decimales));
    } else {
      this.activateedPrecioOrden = false;
    }

  }

  ngOnDestroy(): void {
    this.subtema?.unsubscribe();
    this.clearMarketCountdown();
    clearTimeout(this.whatIfDebounce);
  }
}
